import { Directive } from 'vue';

interface Directives {
  [key: string]: Directive
}

const directives: Directives = {
	'click-outside': {
		beforeMount(element, binding) {
			element.clickOutsideEvent = (event: Event) => {
				if (!(element === event.target || element.contains(event.target as Node))) {
					binding.value(event);
				}
			};

			document.body.addEventListener('click', element.clickOutsideEvent);
		},
		beforeUnmount({ clickOutsideEvent }) {
			document.body.removeEventListener('click', clickOutsideEvent);
		},
	},
};

export default directives;
